const isYznDebug = process.env.NODE_ENV === "yzndebug"
const isDev = process.env.NODE_ENV === "development" || isYznDebug
const devConfig = {
    baseURL: "http://192.168.22.83:8086", // 冯光详
    organid: "3d31e70ff5b84e79bb484b69ee0a33f3",
    isDev,
    isYznDebug
}

const prodConfig = {
    baseURL: "//yixue.cqvip.com",
    organid: "3d31e70ff5b84e79bb484b69ee0a33f3",
    isDev,
    isYznDebug
}

const config = isDev ? devConfig : prodConfig

if (typeof module !== "undefined" && module.exports) module.exports = config;
if (typeof define === "function") define(function() { return config; });
